import styled from 'styled-components';
import type { Brand } from './logos';

type Size = 'sm' | 'md';

const BRAND_BG: Record<Brand, string> = {
  claude: '#fadcc8',
  chatgpt: '#cfe9dd',
  perplexity: '#cfeaec',
  grok: '#ededee',
  other: '#f1f2f3',
};

export const StyledAvatar = styled.div<{ $brand: Brand; $size: Size }>`
  width: ${(p) => (p.$size === 'sm' ? '28px' : '40px')};
  height: ${(p) => (p.$size === 'sm' ? '28px' : '40px')};
  border-radius: 50%;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  overflow: hidden;
  background: ${(p) => BRAND_BG[p.$brand]};
  svg {
    width: ${(p) => (p.$size === 'sm' ? '68%' : '64%')};
    height: ${(p) => (p.$size === 'sm' ? '68%' : '64%')};
    display: block;
  }
`;
